import Service from './Service'

class Campaigns extends Service {
  get (params) {
    params.request = 'getCampaigns'

    return this.fetchAllRecords('', params)
          .catch(response => this.handleErrorResponse(response))
  }

  getCampaigns (id) {
    return this.connection.get('events/' + id + '/campaigns', {})
            .then(response => {
              return response.data.records
            })
            .catch(response => this.handleErrorResponse(response))
  }

  addCampaign (campaign, id) {
    campaign.mode = 'post'
    if (campaign.rewards.sumOff !== undefined && campaign.rewards.sumOff === 0) {
      delete campaign.rewards.sumOff
    }
    return this.connection.requestSpea('events/' + id + '/campaigns', campaign)
        .then(response => {
          return response
        })
  }

  edit (id, campaign) {
    let request = 'events/' + id + '/campaigns/' + campaign.campaignId
    campaign.mode = 'patch'
    return this.connection.requestSpea(request, campaign)
        .then(response => {
          return this.handleEmptyResponse(response)
        })
        .catch(response => this.handleErrorResponse(response))
  }

  remove (id, campaign) {
    let request = 'events/' + id + '/campaigns/' + campaign.campaignId
    return this.connection.requestSpea(request, {mode: 'delete'})
      .then(response => {
        return this.handleEmptyResponse(response)
      })
      .catch(response => this.handleErrorResponse(response))
  }
}
export default Campaigns



// WEBPACK FOOTER //
// ./src/api/Service/Campaigns.js